import React from "react";

const PPPStrategySection = () => {
  const strategyPoints = [
    "Active Monitoring of NCP Tenders across all ministries and authorities",
    "Consortium Formation with technical and financial partners in each domain",
    "Bid Management & RFP Submission in compliance with NCP, MOF, and sectoral regulations",
    "Project Development & Feasibility Analysis including financial modeling and risk assessment",
    "Local Content Integration to ensure alignment with Saudi Vision 2030 and localization mandates",
    "Long-Term Operations & Sustainability Planning in line with global PPP best practices"
  ];

  return (
    <section 
      className="relative py-12 sm:py-16 md:py-20"
      style={{
        background: "linear-gradient(to bottom, #c99c48 0%, #8b7035 50%, #4a4a4a 100%)",
      }}
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8 sm:mb-12" data-aos="fade-up">
            <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4 leading-tight">
              Our PPP Participation Strategy
            </h2>
            <div className="w-12 sm:w-16 md:w-24 h-1 bg-white mx-auto mb-6 sm:mb-8"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start lg:items-center">
            <div data-aos="fade-right">
              <p className="text-base sm:text-lg text-gray-100 mb-6 sm:mb-8 leading-relaxed">
                Semar Holding's strategy is built on a comprehensive engagement model designed to target all active and upcoming PPP domains under the NCP framework. We aim to establish consortiums and Special Purpose Vehicles (SPVs) with leading global partners to pursue high-impact PPP projects across Saudi Arabia.
              </p>
              <p className="text-base sm:text-lg text-gray-100 leading-relaxed">
                Our strategy is centered on:
              </p>
            </div>

            <div data-aos="fade-left">
              <div className="space-y-3 sm:space-y-4">
                {strategyPoints.map((point, index) => (
                  <div key={index} className="flex items-start space-x-3 sm:space-x-4">
                    <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-[#c99c48] rounded-full flex items-center justify-center">
                      <span className="text-white font-bold text-xs sm:text-sm">{index + 1}</span>
                    </div>
                    <p className="text-sm sm:text-base text-gray-100 leading-relaxed">{point}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PPPStrategySection;
